<template>
  <div>
    <div class="fixed z-50 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" @click="closeImagePreview()"></div>
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <button type="button" class="rounded-md text-gray-100 hover:text-gray-50 focus:outline-none absolute top-4 right-4" @click="closeImagePreview()">
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
        <div class="inline-block align-bottom bg-white text-left overflow-hidden shadow transform transition-all sm:my-8 sm:align-middle max-w-3xl w-full">
            <div class="shadow-sm bg-white p-1 relative" v-if="this.image_extension == 'pdf'">
                 <embed :src="url+'/storage/'+image_path" width="100%" height="500px" />
                <p class="px-3 py-1.5 bg-gray-900 bg-opacity-80 opacity-90 text-white text-xs font-medium tracking-wider inline-flex rounded-full absolute bottom-3 left-3 break-all">{{image_file_name}}</p>
            </div>
             <div class="shadow-sm bg-white p-1 relative" v-else>
                <img class="block w-full" :src="url+'/storage/'+image_path">
                <p class="px-3 py-1.5 bg-gray-900 bg-opacity-80 opacity-90 text-white text-xs font-medium tracking-wider inline-flex rounded-full absolute bottom-3 left-3 break-all">{{image_file_name}}</p>
            </div>
        </div>
    </div>
</div>
</div>
</template>

<script>
import { siteUrl } from '../../config/base';
export default {
props :["image_file_path","image_file_name"],
  components: {

  },
  data() {
    return {
        image_path:"",
        image_extension:"",
        url:siteUrl,
    };
  },
  created(){
      this.image_path = this.image_file_path;
      this.image_extension = this.image_path.split(".").pop();
  },
  methods: {
   closeImagePreview(){
       this.$emit('close_image_preview');
   }
  }
};
</script>

<style scoped>
</style>
